export default __webpack_public_path__ + "assets/icons/delivery.e8aefc9e.svg";